import type * as pf from '@amirada/lib-shared'
import type * as tp from '@base/utils/types'
import { useSearchStore } from '@base/stores/searchStore'
import { useAppIndexStore } from '@base/stores/indexStore'
import { ut_returnNewRoute } from '@base/utils/utils'

export function useSearch() {
  const indexStore = useAppIndexStore()
  const searchStore = useSearchStore()

  const searchData = computed((): pf.SearchResult | undefined => {
    const paramData: tp.IParamData = { ...indexStore.state.paramData }
    const searchData: pf.SearchResult | undefined = searchStore.getSearchData(paramData)
    if (!searchData) { return }
    return searchData
  })

  async function loadMore(): Promise<void> {
    const paramData: tp.IParamData = { ...indexStore.state.paramData }
    const cursor: number = searchData.value?.slice.cursor || 0
    const limit: number = searchData.value?.slice.limit || 20
    await searchStore.callSearchData(paramData, cursor + limit, limit)
  }

  const totalCount = computed((): number => {
    return searchData.value?.slice.total || 0
  })

  const useLoadMore = computed((): boolean => {
    return totalCount.value > (searchData.value?.found.length || 0)
  })

  function linkPath(path: string): tp.IParamRouter {
    const indexStore = useAppIndexStore()
    const queryAddType: tp.IQueryAddType = {
      noPageParams: true,
      noGlobalParams: false,
      noPsx: true,
      noHash: true,
      noCustom: true,
      noTab: true,
    }
    return ut_returnNewRoute(indexStore.getCountryLangPath + '/' + path, {}, '', queryAddType)
  }

  return {
    indexStore,
    searchData,
    loadMore,
    totalCount,
    useLoadMore,
    linkPath,
  }
}
